import _ from 'lodash';

import fileUploadTemplate from './file-upload-input.html';

const FILE_SIZE_LIMIT = 1024 * 1024 * 5; // ~5mb

@Inject('$scope')
class FileUploadController {  
  $onInit() {
    this.acceptFile = this.acceptFile || '';
    this.uploadEnabled = this.uploadEnabled !== false;
    this.inputFileSizeLimit = this.fileSizeLimit * 1024 || FILE_SIZE_LIMIT;
  }

  formatBytes(a, b = 2) {
    if (a === 0) return '0 Bytes';
    const c = 1024,
      d = b || 2,
      e = ['Bytes', 'KB', 'MB', 'GB'],
      f = Math.floor(Math.log(a) / Math.log(c));
    return `${parseFloat((a / Math.pow(c, f)).toFixed(d))} ${e[f]}`;
  }

  inputFileChanged($event) {
    this.errors = {
      fileSizeExceeded: false,
    };
    const file = $event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onloadend = this.fileReaderOnLoadEnd.bind(this, file, fileReader);
  }

  fileReaderOnLoadEnd(file, fileReader) {
    this.$scope.$evalAsync(
      this.onFileChanged(
        {
          name: file.name,
          fileType: file.type,
          fileSource: fileReader.result,
        },
        Object.keys(this.errors).every((e) => this.errors[e])
      )
    );
    this.gatherErrors(file, fileReader);
  }

  onFileChanged(fileData, fileErrors) {
    if (this.form) {
      this.form.$setDirty();
    }
    this.fileModel = [fileData];
    this.fileErrors = fileErrors;
    if (this.onFileChangeCb && typeof this.onFileChangeCb === 'function') {
      this.onFileChangeCb({ data: fileData });
    }
  }

  async gatherErrors(file, fileReader) {
    this.errors.fileSizeExceeded = this.validateMaxFileSize(file);

    if (this.acceptFileCheckValidation) this.errors.fileFormatError = this.validateFileType(file);

    switch (this.validateDimensionsForEntity) {
      case 'banner':
        this.errors.banner = await this.validateDimensions(fileReader);
        break;
      case 'thumbnail':
        this.errors.thumbnail = await this.validateDimensions(fileReader);
        break;
      case 'poster':
        this.errors.poster = await this.validateDimensions(fileReader);
        break;
    }

    if (_.get(this, `form.fileName${this.inputFileId}`)) {
      this.form[`fileName${this.inputFileId}`].$setValidity('fileSizeExceeded', !this.errors.fileSizeExceeded);
      this.form[`fileName${this.inputFileId}`].$setValidity('fileFormatError', !this.errors.fileFormatError);
      this.form[`fileName${this.inputFileId}`].$setValidity('banner', !this.errors.banner);
      this.form[`fileName${this.inputFileId}`].$setValidity('thumbnail', !this.errors.thumbnail);
      this.form[`fileName${this.inputFileId}`].$setValidity('poster', !this.errors.poster);
    }
  }

  onDelete() {
    this.fileModel = null;
    this.form[`fileName${this.inputFileId}`].$setValidity('fileSizeExceeded', true);
    this.form[`fileName${this.inputFileId}`].$setValidity('fileFormatError', true);
    this.form[`fileName${this.inputFileId}`].$setValidity('banner', true);
    this.form[`fileName${this.inputFileId}`].$setValidity('thumbnail', true);
    this.form[`fileName${this.inputFileId}`].$setValidity('poster', true);
    this.form[`fileName${this.inputFileId}`].$error = {};
  }

  validateFileType({ type }) {
    return !this.acceptFile.includes(type);
  }

  validateMaxFileSize({ size }) {
    return size > this.inputFileSizeLimit;
  }

  async validateDimensions(file) {
    const img = new Image();

    return new Promise((resolve) => {
      img.src = file.result;

      img.onload = () => {
        switch (this.validateDimensionsForEntity) {
          case 'banner':
            resolve(this.validateBanner(img));
            break;
          case 'thumbnail':
            resolve(this.validateThumbnail(img));
            break;
          case 'poster':
            resolve(this.validatePoster(img));
            break;
          default:
            resolve(false);
        }
      };

      img.onerror = () => {
        resolve(true);
      };
    });
  }

  validateBanner({ height, width }) {
    const banner = {
      width: 1920,
      height: 450,
    };
    return !(height === banner.height && width === banner.width);
  }

  validateThumbnail({ height, width }) {
    const thumbnail = {
      minWidth: 300,
      maxWidth: 500,
      minHeight: 300,
      maxHeight: 500,
    };

    const isFittedToWidthsRange = width >= thumbnail.minWidth && width <= thumbnail.maxWidth;
    const isFittedToHeightsRange = height >= thumbnail.minHeight && height <= thumbnail.maxHeight;

    return !(isFittedToHeightsRange && isFittedToWidthsRange);
  }

  validatePoster({ height, width }) {
    const banner = {
      width: 3518,
      height: 2479,
    };
    return !(height === banner.height && width === banner.width);
  }
}

export default class FileUploadComponent {
  constructor() {
    this.transclude = {
      label: '?label',
    };
    this.template = fileUploadTemplate;
    this.controller = FileUploadController;
    this.bindings = {
      fileModel: '=',
      uploadEnabled: '<',
      fileErrors: '=',
      fileRequired: '<?',
      form: '<?',
      acceptFile: '@?',
      fileExtensionError: '@?',
      acceptFileCheckValidation: '@?',
      inputFileId: '@?',
      fileSizeLimit: '@?',
      deleteEnabled: '<?',
      onFileChangeCb: '&?',
      validateDimensionsForEntity: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/file-upload/components/file-upload-input/file-upload-input-component.js